export const USER_ROLE = 7;
export const ADMIN_ROLE = 2;
export const EMPLOYER_ROLE_NUM = 3;